import { tracking } from '@iwoca/frontend-tracking-library';
import { Accordion, Pill } from '@iwoca/orion';

import styles from './LoanSummaryMobile.module.css';
import { displayCurrency } from '../../../utils/DisplayCurrency';
import { ProbabilityOfOffer } from '../types';

const LoanSummaryMobile = ({
    amount,
    isInSplitTestHighProbability,
    probabilityOfOffer,
    requestedAmount,
    isInSplitInterestOnly,
    productType
}: {
    amount: string;
    isPartnerCustomer: boolean;
    isInSplitTestHighProbability: boolean;
    probabilityOfOffer: ProbabilityOfOffer;
    requestedAmount: number;
    isInSplitInterestOnly: boolean;
    productType: 'credit_facility' | 'flexi24';
}) => {
    function AccordionTitle() {
        return (
            <>
                {probabilityOfOffer === 'high_probability_of_offer' &&
                isInSplitTestHighProbability ? (
                    <div className={styles.accordionTitle}>
                        <span className={styles.accordionTitleText}>
                            Loan summary
                        </span>
                        <Pill
                            variant="green"
                            size="small"
                            className={styles.pill}>
                            High chance of approval
                        </Pill>
                    </div>
                ) : (
                    'View my loan summary'
                )}
            </>
        );
    }

    function EstimatedAmountText() {
        const estimatedAmount = parseInt(amount);

        if (estimatedAmount < requestedAmount) {
            return (
                <li>
                    Your requested amount{' '}
                    <span>{displayCurrency(requestedAmount)}</span>
                </li>
            );
        }
        return (
            <li>
                Estimated amount{' '}
                <span>{displayCurrency(parseInt(amount))}</span>
            </li>
        );
    }

    const renderHeader = () => {
        if (productType === 'credit_facility') {
            return (
                <h3 className={styles.header}>
                    You’re eligible for our Flexi loan*
                </h3>
            );
        }
        if (productType === 'flexi24') {
            return (
                <h3 className={styles.header}>
                    You’re eligible for our Flexi-24 loan*
                </h3>
            );
        }

        return <></>;
    };

    return (
        <Accordion
            onClick={() => tracking.ampli.mobileLoanSummaryOpenend()}
            title={<AccordionTitle />}>
            {renderHeader()}
            <ul className={styles.offerDetails}>
                <li>Repay early for free</li>
                <li>Decision in 24 hours</li>
                <li>Borrow from 1 day to 12 months</li>

                <EstimatedAmountText />

                {isInSplitInterestOnly && (
                    <li>3-month interest-only repayment option</li>
                )}

                <span className={styles.summaryTerms}>
                    *Final terms are subject to the strength of your application
                </span>
            </ul>
        </Accordion>
    );
};

export default LoanSummaryMobile;
